import React, { useState, useEffect } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { dealsMarkedApi, exportDealsMarked, handleFundsecurelist, MarkAsCompleted, markFundingSecured, showToast, usTimezone } from '../Utils/utils';
import ReactPaginate from 'react-paginate';
import { Col, Row, Button } from 'react-bootstrap';
import moment from 'moment';
import Loaderspinner from "../../components/Loader";
import { toast } from "react-toastify";
import ConfirmationModal from "../../components/Modal/ConfirmationModal";
import { Tooltip } from 'react-tooltip'

const DealsMarked = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [fundSecureList, setFundsecureList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [projectId, setProjectId] = useState('');
  let isMarked = localStorage.getItem('role')

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  const fetchFundSecurelist = async () => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token");
      const limit = 10;
      const offset = page * limit;

      const response = await dealsMarkedApi({
        limit,
        offset,
        token,
      });

      setFundsecureList(response?.data || []);

      if ((response?.data?.length || 0) < limit) {
        setTotalPages(page + 1);
      } else {
        setTotalPages(page + 2);
      }

    } catch (error) {
      console.error("Error fetching lenders:", error);
    } finally {
      setLoading(false)
    }
  };
  useEffect(() => {

    fetchFundSecurelist();
  }, [page]);

  const MarkCompleted = async (id) => {
    try {
      setLoading(true);
      setShow(false);
      const token = localStorage.getItem("token");
      const response = await markFundingSecured(id, { token });
      toast.success('Project mark as secured. this project will now move to funding secured.')
      fetchFundSecurelist();

    } catch (error) {
      toast.error(error?.message)
      console.error("Error fetching lenders:", error);
    } finally {
      setLoading(false)
    }
  };


  const exportDeals = async () => {
    try {
      setLoading(true);
      const blobData = await exportDealsMarked();
      // console.log(blobData, "blobData.......")
      if (blobData.size === 6506) {
        showToast("No data available for export.", "error");
        return;
      }

      const blob = new Blob([blobData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Deals_marked.csv");
      document.body.appendChild(link);

      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      showToast(error.message, "error")
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loaderspinner />}
      <div className="g-sidenav-show bg-gray-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />

            <div className="header header-bg pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav
                        aria-label="breadcrumb"
                        className="d-none d-md-inline-block ml-md-4"
                      >
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                          <li className="breadcrumb-item">
                            <Link to="/dashboard">
                              <i className="fas fa-home" />
                            </Link>
                          </li>
                          <li className="breadcrumb-item mt-2">
                            <span className="" style={{ color: "#f6f9fc" }}>Pending Deals</span>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="d-flex justify-content-between">
                        <div className="row">
                          <h5 className="mb-0 w-auto">Pending Funding </h5>
                          <p
                            className="w-auto px-0"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content="Lists projects that have been approved for funding but where funds are not yet secured. Useful for tracking deal progress and identifying cases that need follow-up to move toward funding completion"
                            data-tooltip-place="right"
                          >
                            <i className="fas fa-info-circle" />

                          </p>

                          <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                        </div>
                        <div className="mt-3 mt-lg-0">

                          <button className='export-btn ml-0 ml-lg-3 mt-3 mt-lg-0 mx-2' onClick={exportDeals} ><span>Export</span></button>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Funder</th>
                            <th>Project Name</th>
                            <th>Funded At</th>
                            {/* <th>Capital Partner</th> */}
                            <th>Investment Type</th>
                            {/* <th>Location</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {fundSecureList?.length > 0 ? (
                            fundSecureList.map((project, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="d-flex flex-row align-items-center" style={{ width: "auto", gap: '5px' }}>
                                    <Link to={`/view-project/${project?.id}`} target="_blank">
                                      <button className="viewproject-btn pull-right mb-1">
                                        <span className="text-white">View Project</span>
                                      </button>
                                    </Link>
                                    <button className="viewproject-btn pull-right mb-1" onClick={() => {
                                      setShow(true)
                                      setProjectId(project?.id)
                                    }}>
                                      <span className="text-white">Mark as secured</span>
                                    </button>
                                    {/* <button className="viewproject-btn pull-right  ml-2 mx-2">
                                      <span className="text-white" onClick={() => {
                                        if (project?.closed_at == null && isMarked == 'transaction_cordinator') {
                                          setShow(true)
                                          setProjectId(project?.id)
                                        }
                                      }}
                                      >{project?.closed_at == null ? 'Mark as Completed' : 'Completed'}</span>
                                    </button> */}
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    <span>{project?.user?.about?.name} {project?.user?.about?.lastname}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    <span>{project?.funder?.about?.name} {project?.funder?.about?.lastname}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    <span>{project?.project_name}</span>
                                  </div>
                                </td>

                                <td className="table-user">
                                  {project?.funded_at == null ? <div style={{ width: "120px" }}><span>N/A</span>
                                  </div>
                                    :
                                    <div style={{ width: "120px" }}><span>{usTimezone(project?.funded_at)}</span></div>
                                  }
                                </td>

                                {/* <td className="table-user">
                                  {project?.capital_partner === "MultiFamily" ?
                                    <div style={{ width: "120px" }}>
                                      <span>Multi Family</span>
                                    </div> : project?.capital_partner === "SingleFamily" ?
                                      <div style={{ width: "120px" }}>
                                        <span>Single Family</span>
                                      </div> :
                                      <div style={{ width: "120px" }}>
                                        <span>{project?.capital_partner ? project?.capital_partner : ""}</span>
                                      </div>
                                  }

                                </td> */}

                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    <span>{project?.funder?.about?.invest_type}</span>
                                  </div>
                                </td>

                                {/* <td className="table-user">
                                  <div>
                                    <div className="">{project?.funder?.about?.city && project?.funder?.about?.county ? `${project?.funder?.about?.city}, ${project?.funder?.about?.county}` : project?.funder?.about?.city}</div>
                                  </div>
                                </td> */}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center"><b>No records found</b></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <Row>
                <Col xs={12}>
                  <div className='paginate-css'>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={({ selected }) => setPage(selected)}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </main>
        </div>
      </div>

      {show &&
        <ConfirmationModal
          show={show}
          onClose={() => setShow(false)}
          onConfirm={() => MarkCompleted(projectId)}
          title="Secured Project"
          body="Are you sure to mark this Project as Secured? This project will be moved to Funded Projects."
        />
      }
    </>

  )
}
export default DealsMarked;